import { Component, Inject, signal, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector:'app-error-popup',
    standalone:true,
    imports:[],
    templateUrl: './error-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls:['./error-popup.component.scss']
})
export class ErrorPopup{
    constructor(private dialogRef:MatDialogRef<ErrorPopup>,@Inject(MAT_DIALOG_DATA) public dialogData:any){
        this.initializeData();
    
      }
      message=signal<string>('');
      submessage=signal<string>('');
    
      initializeData(){
        if(!this.dialogData) return;
        console.log(this.dialogData);
        this.message.set(this.dialogData.message);
        this.submessage.set(this.dialogData.submessage);
      }
    
      closePopup(){
        this.dialogRef.close();
    
      }
}